<script>
import Menu from '/src/components/header.vue';
import Rodape from '/src/components/rodape.vue';

export default {
  name: 'Inspe',
  components: {
    Menu,
    Rodape,
  },
  data() {
    return {
      showModal: false, // Estado para controlar a visibilidade do modal
      selectedImage: '', // Caminho da imagem selecionada
    };
  },
  methods: {
    openModal(imageSrc) {
      this.selectedImage = imageSrc; // Define o caminho da imagem diretamente
      this.showModal = true; // Exibe o modal
    },
    closeModal() {
      this.showModal = false; // Oculta o modal
      this.selectedImage = ''; // Limpa a imagem selecionada
    },
  },
}
</script>

<template>
  <Menu></Menu>
  <div class="clientes">

    <div class="titulo">
      INSPEÇÕES
    </div>
    <div class="bloco1">
      <div class="texto">
        <ul>
          <li>Inspetor de Soldagem Nível 1 e Nível (ASME e AWS)</li>
          <li>Inspetor de Partículas Magnéticas.</li>
          <li>Inspetor de Líquido Penetrante.</li>
          <li>Inspetor de Pintura Nível 1 e Nível 2 (SNQC) e (ABRACO).</li>
          <li>Inspetor de Fabricação Nível 1 e Nível 2.</li>
          <li>Inspetor Dimensional Nível 2.</li>
          <li>Inspetor de Ultrassom Nível 2 (S2/S2.1/S4) e (ASNT).</li>
          <li>Inspetor de Equipamentos (NR13, Vaos e Caldeiras).</li>
          <li>Inspetor Nível 3 de Ensaios não Destrutíveis (END) ABENDI.</li>
          <li>Diligenciamento e Fiscalização em Obras.</li>
          <li>Inspetor de Revestinemto Refratário.</li>
          <li>Técnico de Metrologia e Documentação.</li>
        </ul>
      </div>
      <div class="imagens">
        <div class="image1">
          <img class="imagem" src="../assets/inspecoes/inspe1.jpeg" alt=""
            @click="openModal(require('@/assets/inspecoes/inspe1.jpeg'))">
          <img class="imagem" src="../assets/inspecoes/inspe2.jpeg" alt=""
          @click="openModal(require('@/assets/inspecoes/inspe2.jpeg'))">
        </div>
        <div class="image1">
          <img class="imagem" src="../assets/inspecoes/inspe3.jpeg" alt=""
          @click="openModal(require('@/assets/inspecoes/inspe3.jpeg'))">
          <img class="imagem" src="../assets/inspecoes/inspe4.jpeg" alt=""
          @click="openModal(require('@/assets/inspecoes/inspe4.jpeg'))">
        </div>
      </div>
    </div>
  </div>

  <!-- Modal -->
  <div v-if="showModal" class="modal" @click="closeModal">
    <div class="modal-content" @click.stop>
      <img :src="selectedImage" class="modal-image">
    </div>
  </div>

  <Rodape></Rodape>
</template>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Bebas+Neue&family=Staatliches&display=swap');

@media (max-width: 900px) {
  .clientes {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background-color: #ffffff;
    width: 100vw;
    padding: 0rem;
    min-height: 53.5vh;
  }

  .imagem {
    width: 8rem;
    height: 8rem;
    object-fit: cover;
    margin: 0rem 0.1rem;
    cursor: pointer;

  }

  .titulo {
    margin: 2rem;
    font-weight: bold;
    color: #2e74c4;
    font-size: 1.2rem;
  }

  .bloco1 {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
  }

  .texto {
    width: 80%;
    margin-bottom: 1rem;
    font-size: 0.8rem
  }

  .imagens {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-bottom: 1rem;

  }

  ul {
    display: flex;
    flex-direction: column;
    align-items: baseline;
    justify-content: center;
    width: 100%;
  }

  li {
    text-align: left;
    color: #444;
    line-height: 1.5rem;
  }
  .modal {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #ffffffc5;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
}

.modal-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: relative;
    max-width: 550px;
    object-fit: cover;
}

.modal-image {
    width: 60%;
    height: auto;
    border-radius: 3px;
}
}

@media (min-width: 901px) {
  .clientes {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background-color: #ffffff;
    width: 100vw;
    padding: 2rem;
    min-height: 53.5vh;
  }

  .imagem {
    width: 15rem;
    height: 10rem;
    object-fit: cover;
    margin: 0rem 0.1rem;
    cursor: pointer;

  }

  .titulo {
    margin: 2rem;
    font-weight: bold;
    color: #2e74c4;
    font-size: 1.2rem;
  }

  .bloco1 {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    width: 100%;
  }

  .texto {
    width: 40%;
  }

  .imagens {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  ul {
    display: flex;
    flex-direction: column;
    align-items: baseline;
    justify-content: center;
    width: 100%;
  }

  li {
    text-align: left;
    color: #444;
    line-height: 1.5rem;
  }
  .modal {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #000000e7;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
}

.modal-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: relative;
    max-width: 550px;
    object-fit: cover;
}

.modal-image {
    width: 60%;
    height: auto;
    border-radius: 3px;
}
}
</style>